import { useMutation } from '@tanstack/react-query';
import { changePassword } from 'api/login-v5';

export const useChangePassword = () =>
  useMutation({
    mutationFn: changePassword,
  });
